import { combineReducers } from "redux";

import crowdInfoStore from "./crowdInfoStore";

export default combineReducers({crowdInfoStore});